const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const SERVICES = {
    PLATFORM_SERVICES: `${API_BASE_URL}/services/platform-services/`,
    PROFILE_SERVICES: (profileId) => `${API_BASE_URL}/services/${profileId}/`,
    PROFILE_SERVICE_CREATE: `${API_BASE_URL}/services/create/`,
    PROFILE_SERVICES_LIST: `${API_BASE_URL}/services/my-services/`,
    PROFILE_SERVICE_DETAIL: (id) => `${API_BASE_URL}/services/my-services/${id}/`,
};

export default SERVICES;